/**
 * Static partner configuration. Display names are raw strings (not translated).
 * FAQ entries reference i18n message ids; copy lives in *.messages.*.js files.
 */

export const PARTNER_SLUGS = Object.freeze({
    PRINCE_EDWARD_COUNTY: 'prince-edward-county',
})

export const PARTNER_REGISTRY = Object.freeze({
    //TODO: the partner config will be filled in later, some shared data might be moved to the DB
    [PARTNER_SLUGS.PRINCE_EDWARD_COUNTY]: {
        contactEmail: 'sherylherle@gmail.com',
        displayName: 'LSTA of PEC',
        faqKeys: [
            'Pec.Faq.whyVisit',
            'Pec.Faq.bestTime',
            'Pec.Faq.gettingThere',
            'Pec.Faq.gettingAround',
            'Pec.Faq.thingsToDo',
            'Pec.Faq.townsToExplore',
            'Pec.Faq.families',
            'Pec.Faq.shortTermRentals',
        ],
        faqSectionTitleKey: 'Pec.Faq.title',
        fullAssociationName: 'Licensed Short Term Accommodators of Prince Edward County',
        location: 'Prince Edward County',
        logoUrl: '/assets/logo/pec-logo.webp',
        province: 'Ontario',
        provinceCode: 'ON',
        slug: PARTNER_SLUGS.PRINCE_EDWARD_COUNTY,
    },
})

/**
 * @param {string | undefined | null} slug
 * @returns {Readonly<typeof PARTNER_REGISTRY[string]> | null}
 */
export function getPartnerConfig (slug) {
    return PARTNER_REGISTRY[slug] ?? null
}

/**
 * @param {string | undefined | null} slug
 * @returns {boolean} true if the slug is valid
 */
export function isValidPartnerSlug (slug) {
    return typeof slug === 'string' && slug in PARTNER_REGISTRY
}
